// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Header_wrapper__1Jad","addon":"Header_addon__2_5f","divider":"Header_divider__1ihD","myAccount":"Header_myAccount__T1co"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/Header/Header.scss
// module id = 929
// module chunks = 0